export const fr = {
  rsvpPage: {
    feedback: {
      banner: {
        thanks: "Merci d'avoir participé à cette opportunité !",
        cta: 'Donnez votre avis',
        description: 'pour que nous puissions améliorer le bénévolat',
      },
    },
    navigation: {
      details: 'Détails',
      volunteers: 'Bénévoles',
      feedback: 'Commentaires',
      photos: 'Photos',
    },
    hero: {
      imageAlt: 'Image de bannière {{name}}',
      cancelled: 'Annulé',
    },
    dateTime: {
      to: 'à',
      labels: {
        sameDay: '{{date}} à {{time}}',
        multiDay: 'Du {{startDate}} au {{endDate}}',
        time: 'De {{startTime}} à {{endTime}}',
      },
    },
    detailsTab: {
      completion: {
        title: 'Opportunité terminée !',
        opportunity_complete: '+1 Opportunité terminée',
        volunteer_hours: '+{{hours}} Heures de bénévolat',
      },
      nonprofit: {
        title: "À propos de l'organisme",
        website_button: 'Visiter le site',
        logo_alt: 'Logo {{name}}',
      },
      photos: {
        title: 'Photos des événements passés',
      },
    },
    feedbackPreview: {
      photos: {
        view_all: 'Voir toutes les photos',
        upload_button: 'Télécharger des photos',
        empty_state: {
          message: "Il n'y a pas encore de photos pour cette opportunité.",
          upload_prompt:
            "Si vous en avez pris, téléchargez-les pour que votre entreprise puisse voir l'impact de votre équipe !",
        },
        validation_error: 'Veuillez télécharger au moins une photo',
        success_message: "Merci d'avoir partagé vos photos !",
      },
    },
    feedbackTab: {
      header: {
        title: 'Résumé des retours',
        responses_collected: '{{responses}}/{{total}} Réponses collectées',
      },
      sections: {
        attendance: {
          title: 'Étiez-vous présent ?',
          responses: '{{count}} Réponse',
          responses_other: '{{count}} Réponses',
          legend: {
            yes: 'Oui',
            no: 'Non',
          },
        },
        satisfaction: {
          title: "Comment avez-vous trouvé l'opportunité ?",
          legend: {
            loved: 'Adoré',
            liked: 'Aimé',
            disliked: 'Pas aimé',
          },
        },
        feedback: {
          positive_title: "Qu'avez-vous aimé dans l'événement ?",
          improvement_title: 'Y a-t-il des points à améliorer ?',
          no_attend_title: "Raison de l'absence",
          empty_state: '--',
        },
      },
    },
    photosTab: {
      header: {
        title: 'Photos',
        description:
          "Vous n'avez pas assisté à l'événement ? Ce n'est pas grave ! Vous pouvez toujours télécharger des photos de l'événement pour les partager avec d'autres.",
      },
      form: {
        photos_hint: 'Glissez-déposez vos photos ici ou cliquez pour parcourir',
        submit_button: 'Soumettre',
      },
    },
    joinBlock: {
      status: {
        volunteering: 'Vous êtes bénévole !',
        closed: 'Inscriptions fermées',
        full: 'Opportunité complète',
        pending: "En attente d'approbation",
        sign_in: 'Connectez-vous pour rejoindre',
        waitlisted_one: "Liste d'attente (#{{count}})",
        waitlisted_other: "Liste d'attente (#{{count}})",
        waitlisted_label: "Liste d'attente",
        waitlist_hint: "Vous serez notifie lorsqu'une place se libere",
        waitlist_next: "Vous etes le prochain — vous serez le premier a obtenir une place.",
        waitlist_ahead_one: '{{count}} personne devant vous dans la file.',
        waitlist_ahead_other: '{{count}} personnes devant vous dans la file.',
      },
      buttons: {
        join: "Rejoindre l'evenement",
        leave: "Quitter l'evenement",
        volunteering: 'Vous êtes bénévole',
        add_hours: 'Ajouter des heures',
        edit_hours: 'Modifier des heures',
        join_waitlist: "Rejoindre la liste d'attente",
        leave_waitlist: "Quitter la liste d'attente",
      },
      form: {
        title: 'Réservez votre place',
        fields: {
          full_name: {
            label: 'Nom complet',
            placeholder: 'Nom complet',
          },
          email: {
            label: 'Email',
            placeholder: 'Email',
          },
        },
        submit: 'Rejoindre',
      },
      alerts: {
        joined: "Vous avez rejoint l'evenement !",
        left: "Vous avez quitté l'evenement",
      },
      login_prompt: {
        more_opportunities:
          "pour voir plus d'opportunités dans votre entreprise",
        save_history: "d'abord pour sauvegarder votre historique de bénévolat",
      },
      shifts: {
        title: 'Sélection des quarts',
        choose: 'Choisissez vos quarts',
        select_all: "Sélectionnez tous ceux qui s'appliquent",
        status: {
          open: 'Ouvert',
          full: 'Complet',
          closed: 'Fermé',
          joined: '✓ Vous y êtes',
          adding: '+ Ajout',
          removing: '− Retrait',
          spots_left_one: '{{count}} place restante',
          spots_left_other: '{{count}} places restantes',
          filled: '{{filled}} sur {{total}} places occupées',
          waitlisted: "Liste d'attente #{{position}}",
          join_waitlist: "Rejoindre la liste d'attente",
          joining_waitlist: 'Rejoint',
          waitlist_tap_hint: 'Appuyez pour rejoindre la liste',
          waitlist_leave_tap_hint: 'Appuyez pour quitter la liste',
          queued: 'En file',
          waitlist_next: 'Vous etes le prochain pour ce quart.',
          waitlist_ahead_one: '{{count}} devant vous.',
          waitlist_ahead_other: '{{count}} devant vous.',
        },
        confirmation: {
          removed_all: 'Vous serez retiré de tous les quarts',
          removed_one: 'Retiré de 1 quart',
          removed_other: 'Retiré de {{count}} quarts',
          signed_up_one: 'Vous serez inscrit à {{count}} quart',
          signed_up_other: 'Vous serez inscrit à {{count}} quarts',
          updating: 'Mise à jour...',
          confirm: 'Confirmer les modifications',
          volunteering_count_one: 'Inscrit à {{count}} quart',
          volunteering_count_other: 'Inscrit à {{count}} quarts',
          volunteering: 'Vous êtes bénévole ✓',
          join: 'Rejoindre les quarts',
          hint_change: 'Vous pouvez modifier ou annuler à tout moment',
          hint_tap:
            "Appuyez sur n'importe quel quart ci-dessus pour ajouter ou supprimer",
          join_waitlist_one: "Rejoindre la liste d'attente pour {{count}} quart",
          join_waitlist_other: "Rejoindre la liste d'attente pour {{count}} quarts",
          join_waitlist_loading: "Rejoindre la liste d'attente...",
          waitlist_pending_one: "Vous serez #{{position}} sur la liste d'attente pour {{count}} quart",
          waitlist_pending_other: "Vous rejoindrez la liste d'attente pour {{count}} quarts",
        },
      },
    },
    leaveModal: {
      title: 'Voulez-vous vraiment partir ?',
      message:
        "L'organisme compte sur votre présence, êtes-vous sûr de vouloir quitter cette opportunité ?",
      message_waitlist:
        "Il y a une liste d'attente pour cet événement. Si vous partez, vous devrez rejoindre la liste d'attente pour participer à nouveau.",
      buttons: {
        confirm: "Quitter l'evenement",
        cancel: 'Annuler',
      },
    },
    leaveShiftModal: {
      title_one: 'Voulez-vous vraiment quitter ce quart ?',
      title_other: 'Voulez-vous vraiment quitter ces {{count}} quarts ?',
      message_one:
        "L'organisme compte sur votre présence, êtes-vous sûr de vouloir supprimer ce quart ?",
      message_other:
        "L'organisme compte sur votre présence, êtes-vous sûr de vouloir supprimer ces quarts ?",
      buttons: {
        confirm_one: 'Supprimer le quart',
        confirm_other: 'Supprimer les quarts',
        cancel: 'Annuler',
      },
    },
    locationBlock: {
      virtual_event: 'Événement virtuel',
      self_directed: 'Partout',
      event_link: "Lien de l'événement",
      event_link_later: "Le lien de l'événement sera fourni ultérieurement",
    },
    loginPrompt: {
      login: 'Connexion',
      signup: 'inscription',
      or: 'ou',
    },
    loginToCancelModal: {
      title: 'Compte actif',
      message: 'Nous voyons que vous avez un compte chez nous ! Veuillez',
      login_link: 'vous connecter',
      action: 'pour annuler.',
    },
    memberModal: {
      title: 'Bénévoles',
      empty_state: 'Pas encore de bénévoles. Soyez le premier à rejoindre !',
      see_whos_going: 'pour voir qui participe !',
    },
        leaveWaitlistModal: {
      title: "Quitter la liste d'attente",
      message: "Etes-vous sur ? Si vous partez, vous devrez rejoindre la liste d'attente depuis le debut.",
      buttons: {
        confirm: "Quitter la liste d'attente",
        cancel: 'Annuler',
      },
    },
        waitlistModal: {
      title: "Rejoindre la liste d'attente",
      description: "Vous serez notifie par e-mail lorsqu'une place se libere et que vous etes ajoute a l'evenement.",
      ahead_count_zero: "Il n'y a personne avant vous sur la liste d'attente.",
      ahead_count: 'Il y a actuellement <bold>{{count}} personnes</bold> avant vous sur la liste d\'attente.',
      buttons: {
        confirm: "Rejoindre la liste d'attente",
        cancel: 'Annuler',
      },
    },
        teamModal:{
      title: "Demande de participation à un événement d'équipe",
      top_text: "Cet événement est limité à une équipe spécifique et nécessite l'approbation de l'organisateur de l'événement. Nous vous enverrons un e-mail une fois votre demande examinée.",
      bottom_text: "Vous pouvez vérifier le statut à tout moment dans Mon bénévolat.",
    },
    addVolunteersModal: {
      form: {
        label: 'Ajouter un bénévole',
        hint: "Vous ne trouvez pas un utilisateur ? Tapez un email et appuyez sur entrée pour l'ajouter",
        submit_button: 'Soumettre',
      },
      success_message: 'Bénévoles ajoutés',
    },
    inviteVolunteersModal: {
      form: {
        label: 'Inviter un bénévole',
        hint: "Vous ne trouvez pas un utilisateur ? Tapez un email et appuyez sur entrée pour l'ajouter",
        submit_button: 'Soumettre',
      },
      success_message: "Emails d'invitation envoyés",
    },
    shareBlock: {
      title: 'Partager',
      buttons: {
        copy_invite: "Copier l'invitation",
        add_calendar: 'Ajouter au calendrier',
      },
      calendar_options: {
        google: 'Google Agenda',
        apple: 'Calendrier Apple',
        outlook: 'Calendrier Outlook',
      },
      invite_template: {
        header:
          'Nouvelle opportunité de bénévolat : Rejoignez-nous pour {{name}} avec {{nonprofitName}} !',
        when: 'Quand : {{datetime}} {{timezone}}',
        where: 'Où : {{location}}',
        virtual: {
          with_link: 'Virtuel ({{link}})',
          no_link: "Virtuel (Lien de l'événement à venir)",
        },
        signup: 'Inscrivez-vous ci-dessous',
        join_others:
          ' et rejoignez {{names}}{{overflow}} pour du bénévolat amusant :',
        join_count:
          ' et rejoignez {{count}} autres personnes pour du bénévolat amusant :',
        overflow_text: {
          single: ' et {{count}} autre collègue',
          multiple: ' et {{count}} autres',
        },
      },
      alerts: {
        copied: "Message d'invitation copié dans le presse-papiers",
      },
    },
    volunteersBlock: {
      count: {
        volunteers: '{{current}}/{{capacity}} Bénévoles',
      },
    },
    volunteersTab: {
      table: {
        title: 'Bénévoles',
        subtext:
          "Gérez les participants et consultez leurs retours une fois l'événement terminé",
        columns: {
          name: 'Nom',
          joined: 'A rejoint',
          feedback_status: 'Statut du retour',
          rating: 'Evaluation',
          attended: 'A participe',
          volunteer_hours: 'Heures de benevolat',
          status: 'Statut',
          waitlist_position: "Liste d'attente #",
        },
      },
      actions: {
        hide_invite: "Masquer l'invitation",
        remove_volunteer: 'Retirer le bénévole',
        add_volunteers: 'Ajouter des bénévoles',
        edit_hours: 'Modifier les heures',
        invite_volunteers: 'Inviter des bénévoles',
        save: 'Enregistrer',
        cancel: 'Annuler',
      },
      alerts: {
        email_copied: '{{email}} copié dans le presse-papiers',
        hours_updated: 'Heures de bénévolat mises à jour',
        invite_copied: "Message d'invitation copié dans le presse-papiers",
      },
      empty_state: {
        title: 'Pas encore de bénévoles',
        description:
          "Invitez quelqu'un à rejoindre cet événement et créez un impact ensemble !",
        copy_invite: "Copier le message d'invitation",
      },
      attendance: {
        yes: 'Oui',
        no: 'Non',
        pending: '—',
      },
      invite_template: {
        title:
          'Nouvelle opportunité de bénévolat : Rejoignez-nous pour {{name}} avec {{nonprofitName}} !',
        when: 'Quand : {{datetime}}',
        where: 'Où : {{location}}',
        virtual: {
          with_link: 'Virtuel ({{link}})',
          no_link: "Virtuel (Lien de l'événement à venir)",
        },
        signup: 'Inscrivez-vous ci-dessous :',
      },
      headerActions: {
        save: 'Enregistrer',
        cancel: 'Annuler',
        add_volunteers: 'Ajouter des bénévoles',
        edit_hours: 'Modifier les heures',
        invite_volunteers: 'Inviter des bénévoles',
      },
      emptyState: {
        title: 'Pas encore de bénévoles',
        description:
          "Invitez quelqu'un à rejoindre cet événement et créer un impact ensemble !",
        copy_invite: "Copier le message d'invitation",
      },
      labels: {
        invited: '(invite)',
        waitlisted: '(en attente)',
        virtual: 'Virtuel',
        virtual_link_later: "Virtuel (Lien de l'evenement a venir)",
      },
      filters: {
        label: 'Type',
        all: 'Tous',
        attending: 'Participants',
        waitlisted: 'En attente',
      },
    },
    confirmRemoveVolunteerModal: {
      title: 'Retirer le bénévole',
      message:
        'Êtes-vous sûr de vouloir retirer {{name}} en tant que bénévole de cette opportunité ?',
      buttons: {
        confirm: 'Oui',
        cancel: 'Non',
      },
    },
    confirmHideInviteModal: {
      title: "Masquer l'invitation",
      message:
        "Êtes-vous sûr de vouloir masquer l'invitation envoyée à <0>{{email}}</0>? Une invitation a été envoyée par e-mail et ne peut pas être rétractée.",
      buttons: {
        confirm: 'Oui',
        cancel: 'Non',
      },
    },
    eventCard: {
      tags: {
        communityAction: 'Action Communautaire',
        singleEvent: 'Événement Unique',
      },
      spots: {
        completed: 'Complété',
        waitlistOpen: "Liste d'attente ouverte",
        eventFull: 'Événement complet',
        almostFull_one: 'Presque complet · {{count}} place disponible',
        almostFull_other: 'Presque complet · {{count}} places disponibles',
        fillingUp_one: 'Se remplit · {{count}} place disponible',
        fillingUp_other: 'Se remplit · {{count}} places disponibles',
        open_one: 'Ouvert · {{count}} place disponible',
        open_other: 'Ouvert · {{count}} places disponibles',
      },
      location: {
        virtual: 'Virtuel',
        selfDirected: 'Partout',
      },
      volunteers: '{{count}}/{{total}} bénévoles',
    },
    nonprofitProfile: {
      stats: {
        events: 'Événements',
        volunteers: 'Bénévoles',
        hoursVolunteered: 'Heures bénévoles',
        companyImpactTitle: "L'impact de votre entreprise",
      },
      sections: {
        about: 'À propos',
        gallery: 'Photos',
        upcomingEvents: 'Événements à venir',
        pastEvents: 'Événements passés',
        noUpcomingEvents: 'Aucun événement à venir',
        noPastEvents: 'Aucun événement passé',
        orgInfo: "Infos sur l'organisme",
        location: 'Emplacement',
        website: 'Site web',
      },
    },
  },
  feedbackModal: {
    attendance: {
      title: 'Avez-vous assisté ?',
      description:
        "Maintenant que l'événement est terminé, faites-nous savoir si vous avez pu y assister",
      buttons: {
        yes: 'Oui',
        no: 'Non',
      },
    },
    noAttendReason: {
      title: 'Merci de nous avoir informés !',
      description:
        "Si vous êtes à l'aise de partager, faites-nous savoir pourquoi vous n'avez pas pu y assister",
      placeholder: "Dites-nous pourquoi vous n'avez pas pu assister...",
      buttons: {
        skip: 'Non merci',
        submit: 'Soumettre',
      },
    },
    main: {
      title: "Comment ça s'est passé ?",
      description:
        'Donnez-nous votre avis sur le déroulement de cette opportunité',
      fields: {
        satisfaction: {
          label: "Comment avez-vous aimé l'opportunité ?",
        },
        positive_feedback: {
          label: "Qu'avez-vous aimé dans l'événement ?",
          placeholder:
            "Faites-nous savoir ce qui a rendu l'événement génial pour vous !",
        },
        improvement_suggestions: {
          label: 'Y a-t-il quelque chose qui pourrait être amélioré ?',
          placeholder: "Qu'est-ce que vous n'avez pas aimé ?",
        },
        photos: {
          upload_message:
            'Glissez-déposez vos photos ici ou cliquez pour parcourir',
          greenshield_disclaimer:
            "Veuillez noter que les photographies prises lors des événements Purposely peuvent être utilisées à des fins de communications internes et externes. Cela peut inclure leur utilisation sur notre intranet, dans nos infolettres, rapports, présentations, médias sociaux et autres documents d'entreprise.",
        },
      },
      buttons: {
        submit: 'Soumettre',
      },
      validations: {
        satisfaction_required: 'Requis.',
        positive_feedback_required: 'Requis.',
        improvement_required: 'Requis.',
      },
      alerts: {
        success: 'Merci pour vos retours !',
      },
    },
  },
}
